<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M211.61 3563.05l264.6 -264.54 264.6 264.54 264.61 -264.54 264.53 264.54 264.61 -264.54 264.6 264.54 264.6 -264.54 264.61 264.54 264.53 -264.54 264.61 264.54 264.6 -264.54 264.6 264.54 0 -3527.78 -264.6 264.54 -264.6 -264.54 -264.61 264.54 -264.53 -264.54 -264.61 264.54 -264.6 -264.54 -264.6 264.54 -264.61 -264.54 -264.53 264.54 -264.61 -264.54 -264.6 264.54 -264.6 -264.54 0 3527.78zm2645.9 -2293.1l-2116.7 0 0 -352.73 2116.7 0 0 352.73zm0 705.61l-2116.7 0 0 -352.8 2116.7 0 0 352.8zm0 705.54l-2116.7 0 0 -352.73 2116.7 0 0 352.73z"/>
  </g>
 </g>
</svg>
